import React from "react"

const VideoLoom = ({ id }) => {
  const styleContainer = {
    position: "relative",
    paddingBottom: "62.5%",
    height: 0,
  }
  const styleIframe = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  }
  if (!id) return false
  const url = `https://www.loom.com/embed/${id}`
  return (
    <div style={styleContainer}>
      <iframe
        src={url}
        frameBorder="0"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        allowFullScreen={true}
        style={styleIframe}
      ></iframe>
    </div>
  )
}

export default ({ id, source = "loom" }) => {
  if (source === "loom") return <VideoLoom id={id}></VideoLoom>
  return null
}
